import PubSub from "./pubsub.js";

if (!customElements.get("add-product")) {
  class AddProduct extends HTMLElement {
    constructor() {
      super();
      this.pubsub = PubSub;
      this.form = this.querySelector("form.shopify-product-form");

      this.radios = this.querySelectorAll('input[type="radio"].variant-radio');
      this.variantNameSlot = this.querySelector(".variant-name-slot");
      this.variantDescriptionSlot = this.querySelector(
        ".variant-description-slot"
      );

      this.parentSection = this.parentNode.closest("section");

      this.sectionId = this.getAttribute("section-id");

      // this.qty = 1;
      this.id = this.querySelector('input[type="radio"]:checked')?.dataset.id;
    }

    onSubmitHandler = (e) => {
      e.preventDefault();

      const formData = new FormData(this.form);

      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          return response.json();
        })
        .catch((error) => {
          console.error("Error:", error);
        })
        .finally(() => {
          this.pubsub.pub('cart:rerender');
          setTimeout(() => {
            this.pubsub.pub('cart:add');
          }, 300);
        });
        ;

      // formData.append({"sections": "cart-items,cart-icon-bubble,cart-live-region-text,cart-footer"});

      // REQUESTING THE CART TO HANDLE THE ADD_TO_CART ACTION
      // this.pubsub.pub("req-add-to-cart", formData);
    };

    onRadioVariantSelect = (e) => {
      if (this.variantNameSlot) {
        this.variantNameSlot.innerText = "";
        this.variantNameSlot.innerText = e.target.dataset.name;
      }

      if (this.variantDescriptionSlot) {
        this.variantDescriptionSlot.innerText = "";
        this.variantDescriptionSlot.innerText =
          e.target.dataset.variantDescription;
      }

      // console.log("e: ", e);

      // GET MAIN PRODUCT SECTION ON RADIO CLICK
      fetch(
        window.location.pathname +
          `?variant=${e.target.id}&section_id=${this.sectionId}`,
        {
          method: "GET",
        }
      )
        .then((response) => {
          return response.text();
        })
        .then((response) => {
          const url = new URL(location);
          url.searchParams.set("variant", e.target.id);
          history.replaceState({}, "", url);

          const html = new DOMParser().parseFromString(response, "text/html");
          const source = html.querySelector(".main-product__container");

          document.querySelector(".main-product__container").innerHTML =
            source.innerHTML;
        });
    };

    connectedCallback() {
      this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
      this.radios.forEach((radio) => {
        radio.addEventListener("click", this.onRadioVariantSelect.bind(this));
      });
    }
    disconnectedCallback() {
      this.form.removeEventListener("submit", this.onSubmitHandler.bind(this));
      this.radios.forEach((radio) => {
        radio.removeEventListener(
          "click",
          this.onRadioVariantSelect.bind(this)
        );
      });
    }
  }
  customElements.define("add-product", AddProduct);
}

if (!customElements.get("product-quantity")) {
  class ProductQuantity extends HTMLElement {
    constructor() {
      super();

      this.qtyInput = this.querySelector('input[type="number"]');
      this.buttons = this.querySelectorAll("button");
    }

    handleClick = (e) => {
      if (e.target.name == "dec") {
        this.qtyInput.stepDown();
      } else if (e.target.name == "inc") {
        this.qtyInput.stepUp();
      }
    };

    connectedCallback() {
      this.buttons.forEach((button) => {
        button.addEventListener("click", this.handleClick.bind(this));
      });
    }
    disconnectedCallback() {
      this.buttons.forEach((button) => {
        button.removeEventListener("click", this.handleClick.bind(this));
      });
    }
  }
  customElements.define("product-quantity", ProductQuantity);
}
